import { ThemeContext } from '@/entities/theme/lib/context'
import { useThemeModel } from '@/entities/theme/model/slice'
import { FC, ReactNode } from 'react'

interface ThemeProviderProps {
  children: ReactNode
}

export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
  const themeState = useThemeModel()

  return <ThemeContext.Provider value={themeState}>{children}</ThemeContext.Provider>
}
